<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
import { fade } from 'svelte/transition';
import uiStore from '../utils/UIStore';

let uiTexts;
uiStore.textStore.subscribe((store) => {
  uiTexts = store.texts;
});
</script>

<footer>
  <a
    target="_blank"
    href="https://www.example.com/"
    title="{uiTexts.footer.logo.title}"
    class="logo"
  >
    <img transition:fade alt="{uiTexts.footer.logo.alt}" src="/logos/footer-logo.png" />
  </a>

  <div
    style="display:flex; flex-direction:column; align-items: start; font-size: 0.8rem;"
  >
    <slot name="version" />
    <span>{uiTexts.footer.builtWith}</span> <!-- Change the buildWith text if license text for Meta not applicable or other license statement necessary or keep it blank. Can be found in translation.json files-->
  </div>

  <slot
    name="links"
  />

  <slot name="close" />
</footer>

<style>
  .logo {
    z-index: 100;
    margin: 0 20px 20px;
    position: fixed;
    bottom: 0px;
    left: 0px;
  }

  .logo img {
    height: 64px;
    width: auto;
  }

  footer {
    height: fit-content;
    width: 100vw;
    padding: 4px;
    bottom: 0;
    left: 0;
    right: 0;
    position: fixed;
    background-color: var(--sec-color);
    z-index: 100;
    color: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 90px;
    padding-right: 24px;
  }

  @media screen and (max-width: 1000px) {
    footer {
      display: none;
    }
  }
</style>
